import React from 'react';
import Formsy from 'formsy-react'
import Input from '../form/Input'
import Very from '../../helpers/request_wrapper'
import Error from '../form/error'

class ChangePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disable: false,
      error: ''
    }
  }

  submit = (data) => {
    this.setState({ disable: true });

    Very.patch(`/users/${this.props.user.id}/update_password`, data).then(response => {
      window.location.replace('/')
    }, response => {
      this.setState({ error: response.error, disable: false })
    })
  };

  render() {
    const { error } = this.state;

    return (
      <React.Fragment>
        <div className="flex flex-center flex-justify-center mh-100vh" style={{ paddingTop: '80px' }}>
          <div className="col-12 md-px3 py-110 sm-py4" style={{ maxWidth: '350px' }}>
            <p className="title center mb-30">Change Password</p>

            {error && <Error message={error} />}

            <Formsy className="mx-auto" style={{ maxWidth: '350px' }} onValidSubmit={this.submit}>
              <div className="mb-20">
                <Input
                  name="user[current_password]"
                  label="Current Password"
                  type="password"
                />
              </div>

              <div className="mb-20">
                <Input
                  name="user[password]"
                  label="New password"
                  type="password"
                />
              </div>

              <div className="mb-20">
                <Input
                  name="user[password_confirmation]"
                  label="Confirm new password"
                  type="password"
                />
              </div>

              <input
                type="submit"
                className="btn btn--primary col-12"
                value="Save"
                disabled={this.state.disable}
              />
            </Formsy>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default ChangePassword;
